import { Actions, createNamespace } from "../../../flux/Actions";

const ns = createNamespace('List');
export const names = {
    SET_ITEMS: ns('SET_ITEMS'),
    REPLACE_ITEMS: ns('REPLACE_ITEMS'),
    UPSERT_ITEMS: ns('UPSERT_ITEMS'),
    REMOVE_ITEMS: ns('REMOVE_ITEMS'),
};

export class ListActions extends Actions
{
    setItems = <T>(items: T[], meta: any) => this.dispatch(names.SET_ITEMS, items, meta);
    replaceItems = <T>(items: T[], meta: any) => this.dispatch(names.REPLACE_ITEMS, items, meta);
    upsertItems = <T>(items: T[], meta: any) => this.dispatch(names.UPSERT_ITEMS, items, meta);
    removeItems = (keys: (number|string)[], meta: any) => this.dispatch(names.REMOVE_ITEMS, keys, meta);
}


// WEBPACK FOOTER //
// ./src/app/flux/Grid/ListActions.ts